export type MediaSortBy = "uploadedAt" | "takenAt" | "name";

export type SortOrder = "asc" | "desc";

export interface MediaSortOptions {
  sortBy: MediaSortBy;
  sortOrder: SortOrder;
}

export const DEFAULT_MEDIA_SORT: MediaSortOptions = {
  sortBy: "takenAt",
  sortOrder: "asc",
};

